import { render, staticRenderFns } from "./fhir-backbone-element.vue?vue&type=template&id=6825cd20&"
import script from "./fhir-backbone-element.vue?vue&type=script&lang=js&"
export * from "./fhir-backbone-element.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports